// 统一管理所有的接口
import { fetch, post } from "@/utils/request";

const baseUrl = "";

// 流量通道获取信息
export const actInfo = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/info";
  return post(url, data);
};

// 流量通道投放统一入口
export const actEntr = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/entr";
  return post(url, data);
};

// 查询短剧链接
export const queryPlayletLink = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/playlet/query";
  return post(url, data);
};

// 营销活动支付接口
export const actPay = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/pay";
  return post(url, data);
};

export const interactRedirect = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/redirect";
  return post(url, data);
};

// 营销活动支付查询接口
export const actQuery = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/pay/query";
  return post(url, data);
};

// 营销活动退款接口
export const actRefund = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/refund";
  return post(url, data);
};

// 营销抽奖接口
export const lotDraw = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/lot/draw";
  return post(url, data);
};

// 抽奖兑奖接口
export const lotCash = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/lot/cash";
  return post(url, data);
};

// 兑奖查询接口
export const lotQuery = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/lot/query";
  return post(url, data);
};

// 开屏曝光数据记录
export const actJump = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/jump";
  return post(url, data);
};

// 根据活动id获取活动信息
export const actActInfo = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/actInfo";
  return post(url, data);
};

// 根据活动id获取活动信息
export const adInfo = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/pay/queryByAdId";
  return post(url, data);
};

// 发送短信验证码
export const sendMsg = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/svc/sendMsg";
  return post(url, data);
};

// 短信验证
export const verifyCode = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/svc/verifyCode";
  return post(url, data);
};

// 权益领取
export const deliverExchange = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/svc/deliver/exchange";
  return post(url, data);
};

// 查询已领取权益
export const deliverList = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/svc/deliver/list";
  return post(url, data);
};

// 查询已领取权益
export const excInfo = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/svc/deliver/status";
  return post(url, data);
};

// 过审短信
export const trialVerifyCode = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/avoiding-trial/verifyCode";
  return post(url, data);
};

// 奖品列表
export const awardList = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/lot/award/list";
  return post(url, data);
};

// 获取用户退款状态接口 如果是短剧 那就是判断状态 如果是其他的权益 那就是真的退款
export const refundStatus = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/refund/user/status";
  return post(url, data);
};

// 营销活动退款接口-短剧
export const refundSketch = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/refund/sketch";
  return post(url, data);
};

// 营销活动退款接口-营销活动短剧退款转换权益
export const refundChangeSvc = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/refund/change/svc";
  return post(url, data);
};

// 根据活动id查询页面模板配置
export const templateConfig = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/page/template/config";
  return fetch(url, data);
};
// 根据paySn查询二次支付的活动信息
export const secpayBySn = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/second-pay/query/by/paySn";
  return fetch(url, data);
};

// 代扣 获取银行列表
export const getBankList = ({ actId, phone }) => {
  const url = baseUrl + "/api/withhold/bank";
  return fetch(url, { actId, phone });
};

// 代扣 退款
export const withholdRefund = (data) => {
  const url = baseUrl + "/api/withhold/refund";
  return post(url, data);
};

// 代扣 查询订单状态 thirdOrderId-三方订单号（推啊） phone-手机号
export const queryOrderStatus = ({ thirdOrderId, phone }) => {
  const url = baseUrl + "/api/withhold/queryInfo";
  return fetch(url, { thirdOrderId, phone });
};

/**
 * 代扣 同步信息
 */
export const syncUserInfo = (data) => {
  const url = baseUrl + "/api/withhold/userinfo/init";
  return post(url, data);
};

/**
 * 代扣 签约绑卡
 */
export const signWithhold = (data) => {
  const url = baseUrl + "/api/withhold/bind";
  return post(url, data);
};

// 代扣 上报埋点
/**
 * 
 * 日志目录：inner日志 （整体日志格式和原来保持一致）
group=5  and type=5 --代扣曝光
业务字段：json字段：orderId （订单ID），pageId（页面ID），phone(base64加密手机号)，pageType:页面类型：1-手机号页面；2-身份证页面
group=5  and type=6 --代扣点击
业务字段：json字段：orderId （订单ID），pageId（页面ID），idCard(base64身份证号)，name(base64姓名)，pageType:页面类型：1-手机号页面；2-身份证页面，
pointType:点击点位类型：
1-手机号输入框点击；
2-手机号页面提交按钮点击（+手机号）；
3-手机号页面隐私协议勾选按钮点击；
4-身份证页面银行卡类型点击；
5-身份证页面返回按钮点击； 没有返回按钮
6-身份证页面银行卡选择按钮点击；
7-身份证页面二要素弹窗曝光；
8-身份证页面二要素弹窗关闭按钮点击；
9-身份证页面姓名输入框点击；
10-身份证页面身份证输入框点击；
11-身份证页面提交按钮点击（+姓名、身份证号）
12-身份证是否永久有效单选项
13-身份证有效期开始时间输入框
14-身份证有效期结束时间输入框

pageId（页面ID） 用actId
 */
export const reportBuriedPoint = ({ type, pointType, json }) => {
  const reportData = { group: 5, pointType, type, json: JSON.stringify(json) };
  // const params = new URLSearchParams(reportData).toString();
  // const url = baseUrl + "/api/withhold/log?" + params;
  // const img = new Image();
  // img.src = url;
  const url = baseUrl + "/api/withhold/log";
  post(url, reportData);
};

// 获取剩余点击次数
export const getClickCount = (data) => {
  const url = baseUrl + "/api/fa/exc/mkt/act/getClickCount";
  return post(url, data);
};

// 会员兑换-支付完成校验
export const memberPayCheck = (data) => {
  const url = baseUrl + "/api/fa/tc/member/pay/check";
  return post(url, data);
};

// 会员兑换-领取会员（错误提示由页面弹框处理，跳过全局 toast）
export const memberExchange = (data) => {
  const url = baseUrl + "/api/fa/tc/member/exchange";
  return post(url, data, { skipErrorToast: true });
};

// 会员兑换-领取记录（错误提示由页面弹框处理，跳过全局 toast）
export const memberExchangeList = (data) => {
  const url = baseUrl + "/api/fa/tc/member/exchange/list";
  return post(url, data, { skipErrorToast: true });
};



// WEBPACK FOOTER //
// ./src/api/url.js